<!-- ======= About Section ======= -->
<section id="about" class="about">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Acerca de Mí</h2>
      <p>
        Soy un desarrollador web front-end, apasionado por el mundo tech.
        Utilizo principalmente el framework Angular en mis desarrollos del día a
        día. Tengo un fuerte sentimiento de propiedad con el código que escribo
        lo que me lleva cada día a querer mejorar. Soy una persona abierta a
        comentarios que desea aprender de las mejores experiencias de cada
        compañero. Busco obtener experiencias que me ayuden a crecer
        profesionalmente. Siempre trato brindar un ámbito laboral cálido para
        poder desarrollar las diferentes tareas en equipo. Me apasiona aprender
        sobre tecnologías nuevas y capacitarme continuamente.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <img
          src="assets/img/profile-img.jpg"
          class="img-fluid"
          alt="foto personal"
          loading="lazy"
        />
      </div>
      <div class="col-lg-8 pt-4 pt-lg-0 content">
        <h3>Frontend Web Developer.</h3>
        <br />
        <div class="row">
          <div class="col-lg-6">
            <ul>
              <li>
                <i class="bi bi-chevron-right"></i>
                <strong>Nombre:</strong>
                <span>Diego Pagini</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Ciudad:</strong>
                <span>Fuengirola, Málaga, España</span>
              </li>
            </ul>
          </div>
          <div class="col-lg-6">
            <ul>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Email:</strong>
                <span>diegopaginidev@gmail.com</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i>
                <strong>Nacionalidad:</strong>
                <span>Italiano / Argentino</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End About Section -->
